{
    "FormEngineJwtDatasource": {
        "title": "JWT Data",
        "description": "Read data from a given JSON Web Token"
    },
    "mask": {
        "FormEngineJwtDatasource": {
            "description": "Description",
            "jwtSource": "Token Source",
            "jwtOutput": "Output Name"
        }
    }
}